import React from 'react'
import "./Organisation.css"
const Organisation = () => {
  return (
    <div>
      <h1>Organisation</h1>
    </div>
  )
}

export default Organisation
